import { useState } from "react";
import { Play } from "lucide-react";

// Extract YouTube video IDs from message text + backend link objects.
// Handles youtube.com/watch?v=, youtu.be/, /shorts/, /embed/ (with or without protocol).
const YT_RE =
  /(?:youtube\.com\/(?:watch\?(?:[^\s]*&)?v=|shorts\/|embed\/|live\/)|youtu\.be\/)([A-Za-z0-9_-]{11})/gi;

export function extractYouTubeIds(text = "", links = []) {
  const ids = [];
  const scan = (s) => {
    if (!s) return;
    YT_RE.lastIndex = 0;
    let m;
    while ((m = YT_RE.exec(s)) !== null) {
      if (!ids.includes(m[1])) ids.push(m[1]);
    }
  };
  scan(text);
  (links || []).forEach((l) => scan(typeof l === "string" ? l : l?.url));
  return ids;
}

// Inline YouTube player — shows the thumbnail (click to play), then embeds a privacy-mode iframe.
export function YouTubeEmbed({ videoId, testid }) {
  const [playing, setPlaying] = useState(false);
  if (!videoId) return null;
  return (
    <div
      className="mt-1.5 aspect-video w-full max-w-[320px] overflow-hidden rounded-xl border border-white/10 bg-black"
      data-testid={testid}
    >
      {playing ? (
        <iframe
          className="h-full w-full"
          src={`https://www.youtube-nocookie.com/embed/${videoId}?autoplay=1&rel=0`}
          title="YouTube video"
          frameBorder="0"
          allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture"
          allowFullScreen
          data-testid={testid ? `${testid}-iframe` : undefined}
        />
      ) : (
        <button
          type="button"
          onClick={() => setPlaying(true)}
          className="group relative block h-full w-full"
          data-testid={testid ? `${testid}-thumb` : undefined}
          aria-label="Play YouTube video"
        >
          <img
            src={`https://i.ytimg.com/vi/${videoId}/hqdefault.jpg`}
            alt="YouTube thumbnail"
            loading="lazy"
            className="h-full w-full object-cover"
          />
          <span className="absolute inset-0 flex items-center justify-center bg-black/25 transition-colors group-hover:bg-black/10">
            <span className="flex h-12 w-12 items-center justify-center rounded-full bg-red-600 text-white shadow-lg transition-transform group-hover:scale-110">
              <Play className="ml-0.5 h-6 w-6 fill-current" />
            </span>
          </span>
        </button>
      )}
    </div>
  );
}
